function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["align", "children", "className", "color", "decoration", "ellipsis", "italic", "size", "transform", "weight"],
  _excluded2 = ["color", "size", "weight"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import { FontColors, FontSizes, FontWeights } from "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import { getFontAlignment, getFontColor, getFontDecoration, getFontSize, getFontTransform, getFontWeight } from "../../../../styles/styled-components/font.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import { truncateText } from "../../../../styles/styled-components/text.js";
import "../../../../styles/styled-components/tooltip.js";
import { BaseText } from "../base-text/base-text.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardText = function BaseStandardText(props) {
  var _classnames;
  var align = props.align,
    children = props.children,
    className = props.className,
    color = props.color,
    decoration = props.decoration,
    ellipsis = props.ellipsis,
    italic = props.italic,
    size = props.size,
    transform = props.transform,
    weight = props.weight,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseText, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-text__standard': true
    }, _defineProperty(_classnames, "bf-text__standard--align-".concat(align), !!align), _defineProperty(_classnames, "bf-text__standard--color-".concat(color), !!color), _defineProperty(_classnames, "bf-text__standard--decoration-".concat(decoration), !!decoration), _defineProperty(_classnames, 'bf-text__standard--ellipsis', ellipsis), _defineProperty(_classnames, 'bf-text__standard--italic', italic), _defineProperty(_classnames, "bf-text__standard--size-".concat(size), !!size), _defineProperty(_classnames, "bf-text__standard--transform-".concat(transform), !!transform), _defineProperty(_classnames, "bf-text__standard--weight-".concat(weight), !!weight), _defineProperty(_classnames, "".concat(className), !!className), _classnames))
  }), children);
};
var Text = styled(BaseStandardText)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: block;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_ref) {
  var align = _ref.align;
  return getFontAlignment({
    align: align
  });
}, function (_ref2) {
  var color = _ref2.color,
    theme = _ref2.theme;
  return getFontColor({
    color: color,
    darkMode: theme.darkMode
  });
}, function (_ref3) {
  var decoration = _ref3.decoration;
  return getFontDecoration({
    decoration: decoration
  });
}, function (_ref4) {
  var ellipsis = _ref4.ellipsis;
  return ellipsis ? truncateText() : '';
}, function (_ref5) {
  var size = _ref5.size;
  return getFontSize({
    size: size
  });
}, function (_ref6) {
  var transform = _ref6.transform;
  return getFontTransform({
    transform: transform
  });
}, function (_ref7) {
  var italic = _ref7.italic,
    weight = _ref7.weight;
  return getFontWeight({
    italic: italic,
    weight: weight
  });
});
/**
 * A paragraph of text. Text can contain [phrasing content](https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories#phrasing_content) like `<img>` and `<a>` tags. All text needs to be translated by your app.
 *
 * IMPORTANT: You will need to have Brandfolder's `@font-face` for Circular.
 * Consider using `<BrandfolderGlobalStyles>` component with `styled-components`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/p
 *
 * @param props StandardTextProps
 * @returns FunctionComponent<StandardTextProps>
 */
var StandardText = function StandardText(props) {
  var _props$color = props.color,
    color = _props$color === void 0 ? FontColors.Default : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? FontSizes.Small : _props$size,
    _props$weight = props.weight,
    weight = _props$weight === void 0 ? FontWeights.Book : _props$weight,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Text, _extends({}, otherProps, {
    color: color,
    size: size,
    weight: weight
  })));
};
export { BaseStandardText, StandardText };